import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setLocalStorageItem } from "../../../../src/utils/index";
import { Button, Input, message } from "antd";
import { images } from "../../../assets/images";
import { loginApi } from "../../../ApiServices/Apifun"; 

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ email: "", password: "" });

  const handlelogin = () => {
    setLoading(true);
    const data = {
      loginId: userData.email,
      password: userData.password,
    };
    loginApi(data)
      .then((response) => {

        if (response.status) {
          setLocalStorageItem("token", response.data?.access_token);
          setLocalStorageItem("user", response.data?.user);
          setLocalStorageItem("wallet", response.data?.walletBalance);
          setLocalStorageItem("login", true);
          navigate("/dashboard");
          message.success("Vendor Logged In Successfully");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlelogin();
    }
  };
  return (
    <div className="h-screen px-4 bg-[#fff3f3] flex items-center">
      <div className="w-[1200px]  max-w-[100%] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  shadow-[-5px_0px_15px_#ddd]">
        <div>
          <div className="h-[100%]">
            <img
              src={images.login}
              alt="logo"
              className="flex justify-center rounded-s-md items-center object-cover h-[100%]"
            />
          </div>

          {/* <p className=" text-center text-sm  text-white  font-medium">
            With the websites of Ezulix, you can now focus only on functionaries
            for your digital products, while leaving the UI design on us
          </p> */}
        </div>
        <div className="p-12 rounded-e-md bg-white">
          <p className="  text-2xl   block text-rgbaprimary9  font-medium mb-6">
            Sign In
          </p>
          <div className=" my-4">
            <label
              className="block text-rgbaprimary9 text-md font-medium mb-4"
              htmlFor="username"
            >
              Email Address
            </label>
            <Input
              type="email"
              // placeholder="Enter mobile number here..."
              name="email"
              onKeyDown={handleKeyPress}
              required
              className="shadow appearance-none border rounded w-full py-3 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline"
              onChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
            />
          </div>
          <div className="">
            <label
              className="block text-rgbaprimary9 text-md font-medium mb-4"
              htmlFor="password"
            >
              Password
            </label>
            <Input.Password
              // placeholder="Enter password here..."
              name="password"
              onKeyDown={handleKeyPress}
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline mb-7"
              onChange={(e) =>
                setUserData({ ...userData, password: e.target.value })
              }
            />
          </div>

          <Button
            loading={loading}
            type="button"
            className="text-white h-10 bg-rgbaprimary8 w-full font-semibold"
            onClick={handlelogin}
          >
            Login
          </Button>
          {/* <p onClick={()=>navigate("/register")} className="text-center flex justify-end mt-5  underline cursor-pointer text-rgbaprimary8">Register Now ?</p> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
